import React, { forwardRef } from 'react';
export const Header = forwardRef(({ children }, ref) => {
    return (React.createElement("header", { ref: ref, className: "header" }, children));
});
export const SubHeader = ({ onClick, children }) => {
    return (React.createElement("div", { className: "subheader", onClick: onClick },
        React.createElement("div", { className: "content" }, children)));
};
//# sourceMappingURL=Header.js.map